import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {ShareComponent} from './share/share.component';
import {BreakpointObserver} from '@angular/cdk/layout';


export interface DialogData {
  show: boolean;
}

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.css']
})
export class InfoDialogComponent implements OnInit {
  public link: string;
  public isSmallScreen: boolean;

  constructor(public dialog: MatDialog,
              public dialogRef: MatDialogRef<InfoDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private breakpointObserver: BreakpointObserver,) {
  }

  ngOnInit() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    this.link = location.href;
  }

  onJustClick() {
    this.dialogRef.close();
  }

  openShare() {
    this.dialog.open(ShareComponent, {
      width: '800px',
      panelClass: 'info-overlay'
    });
  }
}
